import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getBalanceTimeline} from '../../../apis/unknownorder/balanceTimeline'

const useQueryBalanceTimeline = (order_id: string) => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.other.getBalanceTimeline(order_id),
        queryFn: async () => {
            const {data} = await getBalanceTimeline(order_id)
            return data
        },
    })

    return {data, refetch}
}

export default useQueryBalanceTimeline
